/** Normaliza texto para comparación insensible a acentos y mayúsculas: "Gómez" y "gomez" matchean. */
export function normalizeForSearch(text: string): string {
  return text.normalize('NFD').replace(/\p{Diacritic}/gu, '').toLowerCase();
}
